@if (datafiles === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading...
	</div>
}

@if (datafiles && datafiles.length === 0) {
	<div class="loading-status">
		No datafiles found.
	</div>
}

@if (datafiles && datafiles.length > 0) {
	<table class="log">
		<thead>
			<tr>
				<th>Filename</th>
				<th>Size</th>
				<th>Import Date ▼</th>
				<th>Exception</th>
			</tr>
		</thead>
		@for (datafile of datafiles; track datafile; let i = $index) {
			<tbody [class.dayspacer]="(datafiles.length > i + 1) && (datafile.imported.clone().startOf('day') > datafiles[i + 1].imported.clone().startOf('day'))">
				<tr>
					<td><a (click)="DownloadFile(datafile)" href="javascript:void(0)"><i class="icon-doc"></i> {{datafile.filename | truncatedfile}}</a></td>
					<td>{{ datafile.size | filesize }}</td>
					<td>{{ datafile.imported | datetime : "local" }}</td>
					<td>
						@if (datafile.exception) {
							<a (click)="ShowException(datafile.exception)" href="javascript:void(0)" [title]="datafile.exception">
								{{ datafile.exception | shortexception }}...
							</a>
						}
					</td>
				</tr>
			</tbody>
		}
	</table>
}

<ng-template #exceptionModal let-c="close">
	<div class="modal-header">
		<h4 class="modal-title">Exception detail</h4>
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="c()"></button>
	</div>
	<div class="modal-body">
		<h3>Exception</h3>
		<pre>{{selectedException | json}}</pre>
		@if (selectedExceptionStack) {
			<div>
				<h3>Stack</h3>
				<pre>{{selectedExceptionStack}}</pre>
			</div>
		}
		@if (selectedExceptionSubStack) {
			<div>
				<h3>Detail stack</h3>
				<pre>{{selectedExceptionSubStack}}</pre>
			</div>
		}
	</div>
</ng-template>